import 'researcher/digital-orders/styles/digital-purchase-features.scss';
import React from 'react';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
var DigitalEditingPurchaseFeatures = function DigitalEditingPurchaseFeatures(_ref) {
  var currency = _ref.currency,
    availableDigitalEditingPurchase = _ref.availableDigitalEditingPurchase;
  return /*#__PURE__*/React.createElement("div", {
    className: "card digital-editing-purchase-features bg-white mt-4 mt-md-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "callout mb-1 font-weight-bold text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Subscription"
  })), /*#__PURE__*/React.createElement("h3", {
    className: "pb-1 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Digital Editing"
  })), availableDigitalEditingPurchase ? /*#__PURE__*/React.createElement(T.md, {
    className: "pricing text-center p-1",
    source: "percent-discounted-digital-editing-annual-price",
    params: {
      price: price(currency, availableDigitalEditingPurchase.price, true, true),
      percent: 30
    }
  }) : null, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-feature-list"
  }), availableDigitalEditingPurchase ? /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-2 pt-1"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-success",
    to: "/researcher/digital-editing/subscribe"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Subscribe"
  }))) : null));
};
export default DigitalEditingPurchaseFeatures;